import { InjectionToken } from '@angular/core';
import { Environment } from '../interfaces/environment.interface';

export const ENVIRONMENT = new InjectionToken<Environment>('Environment');
